import { useState, useEffect } from 'react';
import './Donate.css';
import { PaymentSummary } from './PaymentSummary';
import { useInput, useInputPhone, useInputEmail, useInputPostalCode, useCheckBoxInput } from '../Helpers/FormFieldHelper';
import { submitDonation, payeeErrorCount, honoreeErrorCount, showModal } from '../Helpers/FormHelper';
import { QuestionInfo } from './QuestionInfo';
import { FormPayee } from './FormPayee';
import { FormHonoree } from './FormHonoree';
import { ModalPopup } from '../common/ModalPopup';
import { FormButtonControl } from '../common/FormButtonControl';
import { DonationOptions } from './DonationOptions';
import { AmountSelector } from './AmountSelector';

export function DonateForm() {
  const { value: honoreeFirstName, bind: bindHonoreeFirstName, errorDisp: errorHonoreeFirstName } = useInput("", "Honoree First Name");
  const { value: honoreeLastName, bind: bindHonoreeLastName, errorDisp: errorHonoreeLastName } = useInput("", "Honoree Last Name");
  const { value: honoreeAddress1, bind: bindHonoreeAddress1, errorDisp: errorHonoreeAddress1 } = useInput("", "Honoree Address 1");
  const { value: honoreeAddress2, bind: bindHonoreeAddress2 } = useInput("", "Honoree Address 2");
  const { value: honoreeCity, bind: bindHonoreeCity, errorDisp: errorHonoreeCity } = useInput("", "City");
  const { value: honoreePostalCode, bind: bindHonoreePostalCode, errorDisp: errorHonoreePostalCode } = useInputPostalCode("", "Honoree Postal Code");
  const { value: honoreeEmailAddress, bind: bindHonoreeEmailAddress, errorDisp: errorHonoreeEmailAddress } = useInputEmail("", "Honoree Email");
  const { value: honoreePostalState, bind: bindHonoreePostalState, errorDisp: errorHonoreePostalState } = useInput("", "Honoree State");
  const { value: firstName, bind: bindFirstName, errorDisp: errorFirstName } = useInput("", "First Name");
  const { value: lastName, bind: bindLastName, errorDisp: errorLastName } = useInput("", "Last Name");
  const { value: address1, bind: bindAddress1, errorDisp: errorAddress1 } = useInput("", "Address 1");
  const { value: address2, bind: bindAddress2 } = useInput("", "Address 2");
  const { value: city, bind: bindCity, errorDisp: errorCity } = useInput("", "City");
  const { value: postalCode, bind: bindPostalCode, errorDisp: errorPostalCode } = useInputPostalCode("", "Postal Code");
  const { value: emailAddress, bind: bindEmailAddress, errorDisp: errorEmailAddress } = useInputEmail("", "Email");
  const { value: postalState, bind: bindPostalState, errorDisp: errorPostalState } = useInput("", "State");
  const { value: phone, bind: bindPhone, errorDisp: errorPhone } = useInputPhone("", "Phone");
  const { value: inMemoryName, bind: bindInMemoryName } = useInput("", "In Memory of");
  const { value: occasionName, bind: bindOccasion } = useInput("", "Occasion");
  const { value: conditionChecked, bind: bindConditionCheck, errorDisp: errorConditionCheck } = useCheckBoxInput(false);
  const { value: payeeEmailOptIn, bind: bindPayeeEmailOptIn } = useCheckBoxInput(true);
  const [finalAmount, setFinalAmount] = useState("---");
  const [isMe, setIsMe] = useState(true);
  const [isBehalf, setIsBehalf] = useState(false);
  const [isMemorial, setIsMemorial] = useState(false);
  const [isSecondPart, setIsSecondPart] = useState(false);
  const [formTitle, setFormTitle] = useState("My Contact Information");
  const [popupMessage, setPopupMessage] = useState("");
  const [popupTitle, setPopupTitle] = useState("");
  const [modal, setModal] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [waiting, setWaiting] = useState(false);
  const [modalUrl, setModalUrl] = useState("");
  const [paymentOption, setPaymentOption] = useState("Full");

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const validateForm = async (e, forceInvalidAddress = false) => {
    if (isMemorial && !inMemoryName) {
      setPopupTitle('Validation Problem');
      setPopupMessage('The donation memorial name is required');
      showModal(e, setModal, true);
      return;
    }
    else if (isBehalf && !occasionName) {
      setPopupTitle('Validation Problem');
      setPopupMessage('The donation supporter occasion is required');
      showModal(e, setModal, true);
      return;
    }

    e.preventDefault();
    setWaiting(true);
    let questionList = [];
    questions.forEach((question) => {
      const newQuestion = {
        PersonId: 0,
        Id: question.id,
        QuestionAnswer: question.selectedAnswer,
        QuestionText: question.questionText,
      }
      questionList.push(newQuestion);
    });

    let newPerson = {
      DonationAmount: finalAmount.replace(',', ''),
      HonoreeFirstName: honoreeFirstName || null,
      HonoreeLastName: honoreeLastName || null,
      HonoreeAddress1: honoreeAddress1 || null,
      HonoreeAddress2: honoreeAddress2 || null,
      HonoreeCity: honoreeCity || null,
      HonoreeState: honoreePostalState || null,
      HonoreePostalCode: honoreePostalCode || null,
      HonoreeEmail: honoreeEmailAddress || null,
      PayeeFirstName: firstName || null,
      PayeeLastName: lastName || null,
      PayeeAddress1: address1 || null,
      PayeeAddress2: address2 || null,
      PayeeCity: city || null,
      PayeeState: postalState || null,
      PayeePostalCode: postalCode || null,
      PayeePhoneNumber: phone || null,
      PayeeEmail: emailAddress || null,
      PayeeEmailOptIn: payeeEmailOptIn,
      InMemoryName: isMemorial ? inMemoryName : null,
      OccasionName: isBehalf ? occasionName : null,
      PaymentOption: paymentOption,
    }
    let donationData = {
      Person: newPerson,
      QuestionResponseList: questionList
    }

    await submitDonation(e, donationData, setPopupMessage, setPopupTitle,
      setModal, setModalUrl, setWaiting);
  };

  const inputErrors = () => {
    const payeeErrors = payeeErrorCount(errorEmailAddress, errorPhone, errorPostalCode,
      errorPostalState, errorCity, errorAddress1, errorLastName, errorFirstName);
    let finalCount = payeeErrors;
    if (isBehalf) {
      const honoreeErrors = honoreeErrorCount(errorHonoreeEmailAddress, errorHonoreePostalCode,
        errorHonoreePostalState, errorHonoreeCity, errorHonoreeAddress1,
        errorHonoreeLastName, errorHonoreeFirstName);
      finalCount = payeeErrors + honoreeErrors;
    }
    if (finalAmount === "---" || parseInt(finalAmount) <= 0) {
      finalCount += 1;
    }
    questions.forEach((question) => {
      if (!question.selectedAnswer) {
        finalCount++;
      }
    });
    if (!conditionChecked) {
      finalCount++;
    }

    return finalCount;
  }

  return (
    <div>
      <form className="form-horizontal">
        <div className="row">
          <div className="col-sm-6">
            <DonationOptions setIsMe={setIsMe} isMe={isMe} setIsBehalf={setIsBehalf} isBehalf={isBehalf} setIsMemorial={setIsMemorial}
              isMemorial={isMemorial} setFormTitle={setFormTitle} bindInMemoryName={bindInMemoryName} bindOccasion={bindOccasion} />
          </div>
          <div className="col-sm-6">
            <QuestionInfo finalAmount={finalAmount} setQuestions={setQuestions} questions={questions} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 col-sm-8">
            <div className="mainForm">
              <div className={`${isMe || isMemorial ? "hidden" : ""}`}>
                <FormHonoree isSecondPart={isSecondPart} bindHonoreeFirstName={bindHonoreeFirstName}
                  errorHonoreeFirstName={errorHonoreeFirstName} bindHonoreeLastName={bindHonoreeLastName} errorHonoreeLastName={errorHonoreeLastName}
                  bindHonoreeAddress1={bindHonoreeAddress1} errorHonoreeAddress1={errorHonoreeAddress1} bindHonoreeAddress2={bindHonoreeAddress2}
                  bindHonoreeCity={bindHonoreeCity} errorHonoreeCity={errorHonoreeCity} bindHonoreePostalState={bindHonoreePostalState}
                  errorHonoreePostalState={errorHonoreePostalState} bindHonoreePostalCode={bindHonoreePostalCode}
                  errorHonoreePostalCode={errorHonoreePostalCode} bindHonoreeEmailAddress={bindHonoreeEmailAddress}
                  errorHonoreeEmailAddress={errorHonoreeEmailAddress} isMe={isMe} setIsSecondPart={setIsSecondPart} />
              </div>
              <FormPayee isBehalf={isBehalf} isSecondPart={isSecondPart} formTitle={formTitle} bindFirstName={bindFirstName}
                errorFirstName={errorFirstName} bindLastName={bindLastName} errorLastName={errorLastName} bindAddress1={bindAddress1}
                errorAddress1={errorAddress1} bindAddress2={bindAddress2} bindCity={bindCity} errorCity={errorCity}
                bindPostalState={bindPostalState} errorPostalState={errorPostalState} bindPostalCode={bindPostalCode}
                errorPostalCode={errorPostalCode} bindPhone={bindPhone} errorPhone={errorPhone} bindEmailAddress={bindEmailAddress}
                errorEmailAddress={errorEmailAddress} isMe={isMe} isMemorial={isMemorial} setIsSecondPart={setIsSecondPart} bindPayeeEmailOptIn={bindPayeeEmailOptIn} />
            </div>
          </div>
          <AmountSelector setSelectedGiftAmount={setFinalAmount} selectedGiftAmount={finalAmount} />
        </div>
        <div className="row">&nbsp;</div>
        <PaymentSummary setFinalAmount={setFinalAmount} finalAmount={finalAmount} setPaymentOption={setPaymentOption} />
        <div className="row">
          <div className="col-md-12">
            <label htmlFor="conditionCheckbox">
              <input type="checkbox" className="form-check-input" id="conditionCheckbox" {...bindConditionCheck} /> My donation is given without condition
            </label>
            <div className="formError" style={{ color: "red" }}>
              {errorConditionCheck.map((error, index) => (
                <div key={index}>{error}</div>
              ))}
            </div>
          </div>
        </div>
        <div className="row">&nbsp;</div>
        <FormButtonControl handleSubmit={validateForm} inputErrors={inputErrors} questions={questions} waiting={waiting} />
        <ModalPopup message={popupMessage} title={popupTitle} setModal={setModal} modal={modal} modalUrl={modalUrl} />
      </form>
    </div>
  );
}